import axios from "axios";
import { api } from "../config";
import { POST_LOGIN } from "./url_helper";
import { store } from "..";
import { logoutUser, resetToken } from "../slices/thunks";

// default
// axios.defaults.baseURL = api.API_URL;

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// content type
// axios.defaults.headers.post["Content-Type"] = "application/json";
// content type
// const token = JSON.parse(sessionStorage.getItem("authUser")) ? JSON.parse(sessionStorage.getItem("authUser")).token : null;
// if (token)
//   axios.defaults.headers.common["Authorization"] = "Bearer " + token;

axios.interceptors.request.use((config) => {
  // Do NOT attach token to login or public endpoints
  const isLoginOrPublicEndpoint = config.url.includes(POST_LOGIN);

  if (!isLoginOrPublicEndpoint) {
    const authUserRaw = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUserRaw?.data?.token || authUserRaw?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
  }

  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  } else {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

axios.interceptors.response.use(
  function (response) {
    if (response.config && response.config.responseType === "arraybuffer") {
      return response;
    }

    return response.data ? response.data : response;
  },
  async function (error) {
    const originalRequest = error.config;

    const isResetTokenRequest = originalRequest.url.includes("/refreshtoken");

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isResetTokenRequest
    ) {
      originalRequest._retry = true;
      try {
        const newAuthUser = await store.dispatch(resetToken());
        originalRequest.headers["Authorization"] =
          `Bearer ${newAuthUser.data.token}`;
        return axios(originalRequest);
      } catch (err) {
        store.dispatch(logoutUser());
        return Promise.reject(err);
      }
    }

    if (error.response?.status === 403) {
      sessionStorage.removeItem("authUser");
      window.location.href = "/login";
      return Promise.reject("Access forbidden. Please login again.");
    }

    let message;
    switch (error.status) {
      case 500:
        // window.location.href = "/server-error";
        message = "Internal Server Error";
        break;
      // case 401:
      //   message = "Invalid credentials";
      //   break;
      case 404:
        message =
          error.response?.message || "No bill responses or bill charges found";

        break;
      case 409:
        message =
          error.response.data?.message || "Conflict: Resource already exists.";
        break;
      default:
        message = error.status;
    }
    return Promise.reject(message);
  },
);
/**
 * Sets the default authorization
 @param {*} token
 */
const setAuthorization = (token) => {
  // axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
};

class APIClient {
  /**
   * Fetches data from given url
   */

  get = (url, params = {}, config = {}) => {
    return axios.get(url, {
      params: params,
      ...config,
    });
  };

  // get = (url, params) => {
  //   let response;

  //   let paramKeys = [];

  //   if (params) {
  //     Object.keys(params).map(key => {
  //       paramKeys.push(key + '=' + params[key]);
  //       return paramKeys;
  //     });

  //     const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
  //     response = axios.get(`${url}?${queryString}`, params);
  //   } else {
  //     response = axios.get(`${url}`, params);
  //   }

  //   return response;
  // };

  create = (
    url,
    data = {},
    sendAsQuery = false,
    queryParams = {},
    isPdfDownload = false,
  ) => {
    const axiosConfig = {};

    // If API returns PDF
    if (isPdfDownload) {
      axiosConfig.responseType = "arraybuffer";
      axiosConfig.headers = {
        Accept: "application/pdf",
        "Content-Type": "application/json",
      };
    }

    // if (sendAsRequestQueryParam) {
    //   const encoded = encodeURIComponent(JSON.stringify(data));
    //   return axios.post(`${url}?request=${encoded}`);
    // }
    if (sendAsQuery) {
      const query = new URLSearchParams(data).toString();
      return axios.post(`${url}?${query}`);
    }

    if (Object.keys(queryParams).length > 0) {
      const encoded = encodeURIComponent(JSON.stringify(queryParams));
      return axios.post(
        `${url}?request=${encoded}`,

        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
    }

    return axios.post(url, data, axiosConfig);
  };

  put = (
    url,
    data = {},
    queryParams = {},
    sendAsQuery = false,
    isPdfDownload = false,
    isProfileEdit = false,
  ) => {
    const axiosConfig = {};
    // If API returns PDF
    if (isPdfDownload) {
      axiosConfig.responseType = "arraybuffer";
      axiosConfig.headers = {
        Accept: "application/pdf",
        "Content-Type": "application/json",
      };
    }

    if (isProfileEdit) {
      const encoded = encodeURIComponent(JSON.stringify(queryParams));
      const finalUrl = `${url}?request=${encoded}`;

      if (data instanceof FormData) {
        return axios.put(finalUrl, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return axios.put(finalUrl, data, axiosConfig);
    }

    if (sendAsQuery) {
      // const query = new URLSearchParams(data).toString();
      // return axios.put(`${url}?${query}`);
      const query = new URLSearchParams(queryParams).toString();
      const finalUrl = `${url}?${query}`;

      if (data instanceof FormData) {
        return axios.put(finalUrl, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return axios.put(finalUrl, data, axiosConfig);
    }

    if (sendAsQuery && Object.keys(queryParams).length > 0) {
      const encoded = encodeURIComponent(JSON.stringify(queryParams));
      const finalUrl = `${url}?request=${encoded}`;

      if (data instanceof FormData) {
        return axios.put(finalUrl, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return axios.put(finalUrl, data, axiosConfig);
    }

    if (isProfileEdit) {
      const encoded = encodeURIComponent(JSON.stringify(queryParams));
      const finalUrl = `${url}?request=${encoded}`;

      if (data instanceof FormData) {
        return axios.put(finalUrl, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      return axios.put(finalUrl, data, axiosConfig);
    }

    if (data instanceof FormData) {
      return axios.put(url, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }

    return axios.put(url, data, axiosConfig);
  };

  delete = (url, params = {}, sendAsQuery = false) => {
    if (sendAsQuery && Object.keys(params).length > 0) {
      const query = new URLSearchParams(params).toString();
      return axios.delete(`${url}?${query}`);
    }

    if (Object.keys(params).length > 0) {
      return axios.delete(url, { params });
    }

    return axios.delete(url);
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
